import React from "react";
import Servicespare from "../components/Contact/servicespare"; 
import Banner from '../comman/Banner/Banner';


const Serviceandspare = () => {
  return (
    <>
    <Banner 
     index={'react-spareservice'}
    />
    <Servicespare/>    
    </>

  )
};

export default Serviceandspare;